import { useQuery } from '@tanstack/react-query';
import { getSupabaseClient } from '@/api/supabaseClient';

export function useUnreadNotifications(currentUser, currentMemberId) {
  return useQuery({
    queryKey: ['unreadNotifications', currentUser?.email, currentMemberId],
    enabled: !!currentUser?.email,
    queryFn: async () => {
      const normalizedEmail = (currentUser?.email || '').trim().toLowerCase();
      const supabase = getSupabaseClient();
      const notificationsById = new Map();

      const addNotificationRows = (rows = []) => {
        rows.forEach((row) => {
          notificationsById.set(row.id, {
            id: row.id,
            created_date: row.created_date,
            updated_date: row.updated_date,
            ...(row.data || {}),
          });
        });
      };

      if (normalizedEmail) {
        const { data, error } = await supabase
          .from('notifications')
          .select('id, created_date, updated_date, data')
          .eq('data->>member_email', normalizedEmail)
          .order('created_date', { ascending: false })
          .limit(100);

        if (error) throw new Error(`Notification list failed: ${error.message}`);
        addNotificationRows(data);
      }

      if (currentMemberId) {
        const { data, error } = await supabase
          .from('notifications')
          .select('id, created_date, updated_date, data')
          .eq('data->>member_id', currentMemberId)
          .order('created_date', { ascending: false })
          .limit(100);

        if (error) throw new Error(`Notification list failed: ${error.message}`);
        addNotificationRows(data);
      }

      return [...notificationsById.values()].filter((notification) => {
        if (notification.is_read === true) return false;
        if (String(notification.is_read).toLowerCase() === 'true') return false;
        const email = (notification.member_email || '').trim().toLowerCase();
        if (normalizedEmail && email === normalizedEmail) return true;
        if (currentMemberId && notification.member_id === currentMemberId) return true;
        return false;
      }).sort((left, right) => new Date(right.created_date) - new Date(left.created_date));
    },
  });
}
